<template>
	<div class="loader-info" >
		<img src="../../../../static/website/images/double-ring-spinner.svg" />
	</div>
</template>
<script>
	export default {
		name: 'homepage',
	}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/loader.vue